import { Badge } from '@material-ui/core';
import { useStyles } from './IconWithDot.styles';

interface IconWithDotProps {
  dotHidden?: boolean;
}

const IconWithDot: React.FC<IconWithDotProps> = (props) => {
  const classes = useStyles();

  return (
    <Badge className={classes.badge} color="secondary" variant="dot" overlap="circular" invisible={props.dotHidden}>
      {props.children}
    </Badge>
  );
};

export default IconWithDot;
